import React from 'react';
import cn from 'classnames';
import AnimationWrapper from 'swag-client-common/components/animation-wrapper';
import tcImage from 'assets/img/home/as-seen-on/tc.svg';
import inc500Image from 'assets/img/home/as-seen-on/inc.500.svg';
import incImage from 'assets/img/home/as-seen-on/inc.svg';
import businessInsiderImage from 'assets/img/home/as-seen-on/business-insider.svg';
import forbesImage from 'assets/img/home/as-seen-on/forbes.svg';
import classes from './as-seen-on.scss';
export const AsSeenOn = () => /*#__PURE__*/React.createElement("div", {
  className: classes.containerWrapper
}, /*#__PURE__*/React.createElement("div", {
  className: classes.container
}, /*#__PURE__*/React.createElement("span", {
  className: classes.title
}, /*#__PURE__*/React.createElement(AnimationWrapper, {
  offset: 100
}, /*#__PURE__*/React.createElement("h3", {
  className: classes.titleText
}, "As seen on"))), /*#__PURE__*/React.createElement(AnimationWrapper, {
  offset: 100
}, /*#__PURE__*/React.createElement("div", {
  className: classes.imgContainer
}, /*#__PURE__*/React.createElement("div", {
  className: cn(classes.imgItem, classes.tcImage)
}, /*#__PURE__*/React.createElement("a", {
  href: "https://swag.com/blog/techcrunch-looks-at-promotional-facebook-wework-items-with-swag-com",
  target: "_blank",
  rel: "noreferrer noopener"
}, /*#__PURE__*/React.createElement("img", {
  src: tcImage,
  alt: "Logo of 'TC' with stylized black letters 'T' and 'C' on a light blue background"
}))), /*#__PURE__*/React.createElement("div", {
  className: cn(classes.imgItem, classes.incImage)
}, /*#__PURE__*/React.createElement("a", {
  href: "https://swag.com/blog/inc-com-how-swags-promotional-product-business-started",
  target: "_blank",
  rel: "noreferrer noopener"
}, /*#__PURE__*/React.createElement("img", {
  src: incImage,
  alt: "Logo of 'Inc.' with the text in dark blue, lowercase letters and a light blue dot above the letter 'i'"
}))), /*#__PURE__*/React.createElement("div", {
  className: cn(classes.imgItem, classes.inc500Image)
}, /*#__PURE__*/React.createElement("a", {
  href: "https://swag.com/blog/swag-com-2021-inc-5000-list",
  target: "_blank",
  rel: "noreferrer noopener"
}, /*#__PURE__*/React.createElement("img", {
  src: inc500Image,
  alt: "Logo of Inc. 500 in blue with a stylized number 500 where the number '5' is emphasized",
  className: classes.inc500
}))), /*#__PURE__*/React.createElement("div", {
  className: cn(classes.imgItem, classes.businessInsiderImage)
}, /*#__PURE__*/React.createElement("a", {
  href: "https://swag.com/blog/business-insider-talks-swag-with-co-founders",
  target: "_blank",
  rel: "noreferrer noopener"
}, /*#__PURE__*/React.createElement("img", {
  src: businessInsiderImage,
  alt: "Logo of Business Insider in blue stylized font"
}))), /*#__PURE__*/React.createElement("div", {
  className: cn(classes.imgItem, classes.forbesImage)
}, /*#__PURE__*/React.createElement("a", {
  href: "https://swag.com/blog/forbes-article-about-swag",
  target: "_blank",
  rel: "noreferrer noopener"
}, /*#__PURE__*/React.createElement("img", {
  src: forbesImage,
  alt: "Logo of Forbes in capital letters with a blue color scheme"
})))))));